import React from "react";
import { connect } from "react-redux";
import 'react-select/dist/react-select.css';
import { get } from "lodash";
import Select from "react-select";

import * as authSelectors from "../../redux/auth/selectors";
import * as projectSelectors from '../../redux/projects/selectors'
import * as checklistSelectors from '../../redux/checklists/selectors'

import {
  setProjectId
} from "../../redux/checklists/actions";

export const DEFAULT_SELECT_OPTION = { key: 'PRIVATE', label: 'Private' };

class ChecklistProjectSelect extends React.Component {
  handleChange = (value) => {
    const { setProjectId, checklistProjectId, userId, projectsList } = this.props;
    if (checklistProjectId !== value.key) {

      let isProjectOwner = false;

      if (value.key === 'PRIVATE') {
        isProjectOwner = true
      } else {
        const project = projectsList[value.key];
        isProjectOwner = get(project, 'owner.id') === userId;

        if (!isProjectOwner) {
          const allowMembersToChangeChecklists = get(project, 'allowMembersToChangeChecklists');

          if (allowMembersToChangeChecklists) {
            isProjectOwner = true;
          }
        }
      }

      setProjectId(value.key, isProjectOwner);
    }
  };

  get options() {
    const { projectsList } = this.props;

    const options = [DEFAULT_SELECT_OPTION];

    Object.values(projectsList).forEach(project => {
      if (!project.id) {
        return;
      }

      const option = {
        key: project.id,
        label: project.title,
        ownerId: get(project, 'owner.id')
      };

      options.push(option);
    });

    return options;
  };

  renderCountryOption = option => {
    const { userId } = this.props;

    return (
      <span
        style={{
          fontWeight: option.key === 'PRIVATE' || userId === option.ownerId ? '600' : '400'
        }}
      >
        {option.label}
      </span>
    );
  };

  render() {
    const { checklistProjectId, projectsList, isProjectOwner } = this.props;

    let selectedValue = DEFAULT_SELECT_OPTION;

    if (checklistProjectId) {
      if (checklistProjectId === 'PRIVATE') {
        selectedValue = DEFAULT_SELECT_OPTION;
      } else {
        const project = projectsList[checklistProjectId];
        selectedValue = { key: project.id, label: project.title };
      }
    }

    return (
      <div
        style={{
          position: "fixed",
          top: 8,
          left: 150,
          zIndex: 1300,
          width: 600,
          display: 'flex'
        }}
      >
        <div style={{width: 180, minWidth: 180}}>
          <div
            style={{
              marginBottom: "5px",
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          >
            Choose project
          </div>
          <Select
            className="select-project"
            clearable={false}
            autosize={false}
            onBlurResetsInput={false}
            // arrowRenderer={() => null}
            options={this.options}
            valueKey="label"
            placeholder="Select project"
            onChange={this.handleChange}
            value={selectedValue}
            optionRenderer={this.renderCountryOption}
            // valueRenderer={this.renderCountryValue}
            matchProp="any"
          />
        </div>
        <div style={{
          marginLeft: 10,
          marginTop: 20,
          color: 'rgba(0, 0, 0, 0.54)',
        }}>
          {isProjectOwner ? 'You can edit checklists, change order, delete or create new ones' : 'You are not project owner – you cannot add checklists to this project, edit or delete existing checklists' }
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    userId: authSelectors.getUserId(state),
    projectsList: projectSelectors.projectsList(state),
    checklistProjectId: checklistSelectors.checklistProjectId(state),
    isProjectOwner: checklistSelectors.isProjectOwner(state),
  }),
  {
    setProjectId
  }
)(ChecklistProjectSelect);
